const axios = require('axios').default;
console.log(process.env.NODE_ENV)
console.log(process.env)
let api;
let baseUrl;
let service_api;
let position_amount;
let machine_number;
let api_report;



/*
if(process.env.NODE_ENV.search("local") === 0){

    api =  ("http://"+host[0]+":"+process.env.VUE_APP_API_PORT).toString()+"/api/";
    baseUrl = ("http://"+host[0]+":"+process.env.VUE_APP_API_PORT).toString()+"";
    service_api = process.env.VUE_APP_API_SERVICE;
    position_amount = process.env.VUE_APP_SLOT;
    machine_number = process.env.VUE_APP_MACHINE;

}else{

     api =  process.env.VUE_APP_API;
     baseUrl =  process.env.VUE_APP_BASE;
     service_api = process.env.VUE_APP_API_SERVICE;
     position_amount = process.env.VUE_APP_SLOT;
     machine_number = process.env.VUE_APP_MACHINE;
}*/

api =  process.env.VUE_APP_API;
baseUrl =  process.env.VUE_APP_BASE;
service_api = process.env.VUE_APP_API_SERVICE;
position_amount = process.env.VUE_APP_SLOT;
machine_number = process.env.VUE_APP_MACHINE;
api_report = process.env.VUE_APP_REPORT;



console.log(machine_number)

const instance = axios.create({
    baseURL: api,
    timeout: 20000,
    headers: {
        'X-Custom-Header': 'foobar',
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    }
});

const instance_service = axios.create({
    baseURL: service_api,
    timeout: 2000,
    headers: {
        'X-Custom-Header': 'foobar',
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    }
});


/*
const instance_machine = axios.create({
    baseURL: api_machine,
    timeout: 500000,
    useCredentails: true,
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        'X-Custom-Header': 'foobar'
    }
});
*/


const API = {
    Auth: '/auth/login',
    User: '/users',
    Department: '/department',
    Product: '/products',
    Stock: '/stocks',
    Order: '/order',
    Category: '/category',
    Machine: '/machine',
    Subcategory: '/subcategory',
    ListSubcategory: '/subcategory/list',
}

const SERVICE = {
    CHECK : 'check',
    DEL : 'del_product',
    RESTOER : 'restore_product',
    UPDATE : 'update_product',
    UPDATECategory : 'update_category',
    UPDATEUser : 'update_users',
    UPDATESubcat: 'update_subcat',
}



export { SERVICE,API,instance,baseUrl,position_amount,instance_service,service_api,api_report };
